import * as firebase from 'firebase'

export default {
  methods: {
    async fetchFaqs () {
      const snapshot = await firebase.firestore().collection('SchoolFaqs').where('school_id', '==', this.school.id).orderBy('index').get()
      this.faqs = snapshot.docs.map(doc => doc.data())
    },
  },
  computed: {
    visibleFaqs () {
      const filteredFaqs = this.faqCategoryFilter ? this.faqs.filter((faq) => faq.category ===  this.faqCategoryFilter) : this.faqs
      if (this.searchFaq == null || this.searchFaq.trim().length == 0) return filteredFaqs
      return filteredFaqs.filter((faq) => faq.question.toLowerCase().includes(this.searchFaq.toLowerCase()) || faq.answer.includes(this.searchFaq.toLowerCase()))
    },
    allFaqCategories () {
      return this.$store.state.faqCategories ? this.$store.state.faqCategories : []
    },
    faqCatgories () {
      if (!this.faqs || this.faqs.length === 0) return []
      return this.allFaqCategories.filter((cat) => this.faqs.find((f) => f.category === cat.id))
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/schoolmixin.js